const getKeycloakRole = (keycloakRoles = []) => {
  if (keycloakRoles.includes('Administrador')) {
    return 'Administrador';
  }
  if (keycloakRoles.includes('NOC')) {
    return 'NOC';
  }
  if (keycloakRoles.includes('Monitoreo')) {
    return 'Monitoreo';
  }
  return 'Usuario';
};

export { getKeycloakRole };
